import { HourByHourChart } from '../HourByHourChart/HourByHourChart.component';
import { TemperatureChartCanvas } from './TemperatureChartCanvas.component';
import React, { FC } from 'react';
import { PlcFlatRectLoader } from '@components/Loaders/PlcFlatRectLoader.component';

export interface TemperatureChartProps {
  temperatures: number[];
  cellWidth?: number;
}

const TemperatureChart: React.FC<TemperatureChartProps> = ({ temperatures, cellWidth }) => {
  const chartWidth = temperatures.length * Number(cellWidth);
  return (
    <HourByHourChart>
      <TemperatureChartCanvas chartData={temperatures} chartWidth={chartWidth} />
    </HourByHourChart>
  );
};

const TemperatureChartLoader: FC<{ uniqueKey: string }> = ({ uniqueKey }) => (
  <PlcFlatRectLoader height={250} style={{ width: '100vw' }} uniqueKey={uniqueKey} width={1} />
);

export { TemperatureChart, TemperatureChartLoader };
